ScoreTrekBattle.Template = (function () {
    var _this, STATUS, CONTROL_HANDLERS, CONFIG;

    STATUS = {
        uuid: 0
    };

    CONFIG = {
        maxOptionIndent: 5,
        defaults: {
            __control: {
                'data-control-optional': {
                    placeholder: 'optional',
                    default: 'no'
                },
                'data-control-label': {
                    placeholder: 'show-label',
                    default: null
                },
                'data-control-align': {
                    placeholder: 'align',
                    default: null
                }
            },
            input: {
                text: {
                    minlength: null,
                    maxlength: 255
                },
                number: {
                    min: null,
                    max: null
                },
                time: {
                    step: 60
                }
            },
            select: {
                '': {
                    size: 1
                }
            }
        }
    };

    CONTROL_HANDLERS = {
        input: {
            $get: function() {
                return this.$view.find('input');
            },
            get: function () {
                var input, value;

                input = this.$view.find('input').get(0);

                if (!input) {
                    return null;
                }

                value = String(input.value).trim();

                if (input.dataset.type === 'date') {
                    return DateTime.parseDate(value, true);
                }
                
                if (input.type === 'date') {
                    return DateTime.parseDate(value);
                }
                
                if (input.dataset.type === 'time') {
                    return DateTime.parseTime(value);
                }
                
                if (input.type === 'time') {
                    return DateTime.parseTime(value);
                }
                
                if (input.type === 'datetime-local') {
                    return DateTime.parseDateTime(value);
                }

                return value;
            },
            set: function(value) {
                var $input;

                $input = this.$view.find('input');

                if ($input.attr('data-type') === 'date') {
                    value = DateTime.formatDate(value);
                }

                this.$view.find('input').val(value);

                return this;
            },
            on: function (eventType, eventHandler) {
                var __this = this;
                __this.$view.find('input').on(eventType, function () {
                    eventHandler.apply(__this, arguments);
                });
                return this;
            },
            trigger: function(eventType) {
                this.$view.find('input').trigger(eventType);
                return _this;
            },
            disable: function(isDisabled) {
                isDisabled = (isDisabled !== false);
                this.$view.find('label').toggleClass('isDisabled', isDisabled);
                this.$view.find('input').prop('disabled', isDisabled);
            },
            isDisabled: function() {
                return this.$view.find('input').prop('disabled');
            },
            scrollIntoView: function () {
                AnimationHandler.scrollIntoView(this.$view);
                return this;
            }
        },
        textarea: {
            $get: function() {
                return this.$view.find('textarea');
            },
            get: function () {
                return this.$view.find('textarea').val();
            },
            set: function(value) {
                this.$view.find('textarea').val(value);
                return this;
            },
            on: function (eventType, eventHandler) {
                var __this = this;
                __this.$view.find('textarea').on(eventType, function () {
                    eventHandler.apply(__this, arguments);
                });
                return this;
            },
            trigger: function(eventType) {
                this.$view.find('textarea').trigger(eventType);
                return _this;
            },
            disable: function(isDisabled) {
                isDisabled = (isDisabled !== false);
                this.$view.find('label').toggleClass('isDisabled', isDisabled);
                this.$view.find('textarea').prop('disabled', isDisabled);
            },
            isDisabled: function() {
                return this.$view.find('textarea').prop('disabled');
            },
            scrollIntoView: function () {
                AnimationHandler.scrollIntoView(this.$view);
                return this;
            }
        },
        select: {
            $get: function() {
                return this.$view.find('select');
            },
            get: function () {
                return this.$view.find('select').val();
            },
            getText: function () {
                let $selectedOption;
                
                $selectedOption = this.$getSelectedOption();

                return $selectedOption.attr('data-text') || $selectedOption.text() || '';
            },
            set: function(value) {
                let $select, $selectedOption, selectedValue;
                
                $select = this.$view.find('select');

                $selectedOption = this.$view.find(`select option[value="${value}"]`);

                if ($selectedOption.length === 0) {
                    $selectedOption = this.$view.find('select option').first();
                }

                selectedValue = $selectedOption.attr('value') || '';

                $select.val(selectedValue);

                this.$view.find('.select-text').text(this.getText());

                return this;
            },
            setOptions: function(options, beforeOptions) {
                var $select, value;
                $select = this.$view.find('select');
                value = $select.val();
                $select.empty();

                if (beforeOptions) {
                    renderSelectOptions($select, beforeOptions);
                }
                renderSelectOptions($select, options);

                this.set(value);

                return this;
            },
            $getSelectedOption: function() {
                let $selectedOption;
                
                $selectedOption = this.$view.find('select option:selected');

                if ($selectedOption.length === 0) {
                    $selectedOption = this.$view.find('select option');
                }

                return $selectedOption.first();
            },
            $getOptions: function() {
                return this.$view.find('select option');
            },
            on: function (eventType, eventHandler) {
                var __this = this;
                __this.$view.find('select').on(eventType, function () {
                    eventHandler.apply(__this, arguments);
                });
                return this;
            },
            trigger: function(eventType) {
                this.$view.find('select').trigger(eventType);
                return _this;
            },
            disable: function(isDisabled) {
                isDisabled = (isDisabled !== false);
                this.$view.find('label').toggleClass('isDisabled', isDisabled);
                this.$view.find('select').prop('disabled', isDisabled);
                this.$view.find('.select-text').toggleClass('isDisabled', isDisabled);
            },
            isDisabled: function() {
                return this.$view.find('select').prop('disabled');
            },
            scrollIntoView: function () {
                AnimationHandler.scrollIntoView(this.$view);
                return this;
            }
        },
        checkbox: {
            $get: function() {
                return this.$view.find('input');
            },
            get: function () {
                return this.$view.find('input').prop('checked');
            },
            set: function(value) {
                this.$view.find('input').prop('checked', !!value);
                return this;
            },
            on: function (eventType, eventHandler) {
                var __this = this;
                __this.$view.find('input').on(eventType, function () {
                    eventHandler.apply(__this, arguments);
                });
                return this;
            },
            trigger: function(eventType) {
                this.$view.find('input').trigger(eventType);
                return _this;
            },
            disable: function(isDisabled) {
                isDisabled = (isDisabled !== false);
                this.$view.find('label').toggleClass('isDisabled', isDisabled);
                this.$view.find('input').prop('disabled', isDisabled);
            },
            isDisabled: function() {
                return this.$view.find('input').prop('disabled');
            },
            scrollIntoView: function () {
                AnimationHandler.scrollIntoView(this.$view);
                return this;
            }
        }
    };

    function renderSelectOptions($select, options) {
        if (Array.isArray(options)) {
            options.forEach(optgroup => {
                let $target;

                if (optgroup.label) {
                    $target = $('<optgroup>').attr('label', optgroup.label);
                    if (optgroup.html) {
                        $target.attr('data-html', optgroup.html);
                    }
                    $select.append($target);
                } else {
                    $target = $select;
                }

                renderOptGroupOptions($target, optgroup.options);
            });
        } else {
            renderOptGroupOptions($select, options);
        }
    }

    function renderOptGroupOptions($optGroup, options) {
        Object.keys(options).forEach(key => {
            $optGroup.append(
                renderOption(key, options[key])
            );
        });
    }

    function renderOption(value, option) {
        let text, $html, attributes;

        text = option.hasOwnProperty('text') ? option.text : option;
        $html = option.hasOwnProperty('$html') ? option.$html : $('<span>').text(text);

        attributes = {
            'value': value,
            'data-text': text
        };

        if (option.hasOwnProperty('indent')) {
            attributes['data-indent'] = optionIndent(option.indent);
        }

        return $('<option>').attr(attributes).append($html);

    }

    function optionIndent(indent) {
        indent = parseInt(indent, 10);

        if (isNaN(indent) || (indent < 0)) {
            return 0;
        }

        return Math.min(indent, CONFIG.maxOptionIndent);
    }

    function setDefaultAttributes(elementType, subView) {
        let element, cleanUp;

        element = subView.$get()[0];

        cleanUp = {};

        Object.keys(CONFIG.defaults[elementType] || {}).forEach(type => {
            var isType;

            isType = ((element.getAttribute('type') || '') === type);

            Object.keys(CONFIG.defaults[elementType][type]).forEach(attr => {
                var isDefault, attrValue;

                attrValue = element.getAttribute(attr);
                isDefault = (attrValue === null) || (attrValue === `{{${attr}}}`);

                if (!cleanUp.hasOwnProperty(attr)) {
                    cleanUp[attr] = isDefault;
                }

                if (isType && isDefault) {
                    if (CONFIG.defaults[elementType][type][attr] !== null) {
                        element.setAttribute(attr, CONFIG.defaults[elementType][type][attr]);
                        cleanUp[attr] = false;
                    } else {
                        cleanUp[attr] = true;
                    }
                }
            });
        });

        Object.keys(cleanUp).forEach(attr => {
            if (cleanUp[attr]) {
                element.removeAttribute(attr);
            }
        });

        if (elementType === 'select') {
            subView.$view.find('.select-text').text(subView.getText() || '');
        }

    }

    function setDefaultControlAttributes(element) {
        var cleanUp;

        cleanUp = {};

        Object.keys(CONFIG.defaults.__control).forEach(attr => {
            var isDefault, attrValue;

            attrValue = element.getAttribute(attr);
            isDefault = (attrValue === null) || (attrValue === `{{${CONFIG.defaults.__control[attr].placeholder}}}`);

            if (!cleanUp.hasOwnProperty(attr)) {
                cleanUp[attr] = isDefault;
            }

            if (isDefault) {
                if (CONFIG.defaults.__control[attr].default !== null) {
                    element.setAttribute(attr, CONFIG.defaults.__control[attr].default);
                    cleanUp[attr] = false;
                } else {
                    cleanUp[attr] = true;
                }
            }
        });

        Object.keys(cleanUp).forEach(attr => {
            if (cleanUp[attr]) {
                element.removeAttribute(attr);
            }
        });

    }

    function setDefaultControlHandlers(controlType, subView) {
        subView.focus = function() {
            subView.$get().focus();
        };
        subView.select = function() {
            subView.$get().select();
        };

        if (controlType === 'select') {
            subView.$view.find('.select-text').on('click', function() {
                chmSelect.fromControl(subView);
            });
        }
    }

    function decodeTemplate(templateString) {
        try {
            return templateString;
        } catch (e) {
            console.warn(e);
            return '<div></div>';
        }
    }

    function replaceVars(templateString, templateVars, escapeHTML) {
        templateString = String(templateString);
        templateVars = DataHandler.flattenObject(templateVars);

        Object.keys(templateVars || {}).forEach(key => {
            var replacement;
            replacement = templateVars[key];
            if (replacement === true) {
                replacement = 'yes';
            } else if (replacement === false) {
                replacement = 'no';
            } else if (escapeHTML) {
                replacement = __escapeHTML(replacement);
            }
            templateString = templateString.split(`{{${key}}}`).join(replacement);
        });

        return templateString;
    }

    function renderTemplate(rootView, templateId, templateVars, escapeHTML) {
        var templateString, $template, view;

        view = {
            partial: templateId
        };

        if (!rootView) {
            rootView = view;
        }

        if (!ScoreTrekBattle.ASSETS.TEMPLATES.hasOwnProperty(templateId)) {
            console.warn(`Missing template: ${templateId}`, templateVars);
        }

        templateString = decodeTemplate(ScoreTrekBattle.ASSETS.TEMPLATES[templateId]);
        templateString = replaceVars(templateString, templateVars, escapeHTML);

        $template = $('<div>').attr('data-template', templateId).html(templateString);

        if (!view.controls) {
            view.controls = {};
        }

        if (!view.forms) {
            view.forms = {};
        }

        renderSubTemplates(rootView, $template.get(0), DataHandler.flattenObject(templateVars), escapeHTML);
        __$i18n($template);
        initTemplate($template);

        view.$view = ($template.children().length > 0) ? $template.children() : $template;

        return view;
    }

    function renderSubTemplates(rootView, template, templateVars, escapeHTML) {

        if (template.childNodes.length === 0) {
            return;
        }

        template.childNodes.forEach(childNode => {
            var isSubTemplate, isForm, subTemplateVars, templateId, $childNode, controlId, subView, viewForm;

            isSubTemplate = (String(childNode.tagName).toLowerCase() === 'sub-template');
            isForm = false;

            if (isSubTemplate) {
                subTemplateVars = Object.assign({}, templateVars);
                subTemplateVars.class = '';
                Array.from(childNode.attributes).forEach(attribute => {
                    subTemplateVars[attribute.name] = attribute.value;
                });
                isForm = (subTemplateVars.partial === 'control/form');
            }

            if (isSubTemplate && isForm) {
                if (rootView.currentForm) {
                    console.warn(`Form in form: ${subTemplateVars.control}`);
                }
                rootView.currentForm = subTemplateVars.control;
                viewForm = rootView.currentForm;

                if (rootView.forms.hasOwnProperty(rootView.currentForm)) {
                    console.warn(`Overwriting form reference: ${rootView.currentForm}`)
                }
                rootView.forms[rootView.currentForm] = {
                    view: rootView,
                    fields: [],
                    controls: {},
                    $get: function() {
                        var selector;
                        selector = `form[name="${viewForm}"]`;
                        return rootView.$view.filter(selector).add(rootView.$view.find(selector));
                    },
                    get: function () {
                        var values;
                        values = {};
                        rootView.forms[viewForm].fields.forEach(field => {
                            values[field.name] = CONTROL_HANDLERS[field.type].get.call(field);
                        });
                        return values;
                    },
                    getHidden: function () {
                        var hiddenFields;
                        hiddenFields = [];
                        rootView.forms[viewForm].fields.forEach(field => {
                            var isHidden;
                            isHidden = !CONTROL_HANDLERS[field.type].$get.call(field).closest('[data-control-type]').is(':visible');
                            if (isHidden) {
                                hiddenFields.push(field.name);
                            }
                        });
                        return hiddenFields;
                    },
                    disable: function(isDisabled) {
                        rootView.forms[viewForm].fields.forEach(field => {
                            CONTROL_HANDLERS[field.type].disable.call(field, isDisabled);
                        });
                    },
                    on: function (eventType, eventHandler) {
                        var __this = rootView.forms[viewForm];
                        __this.$get().on(eventType, function () {
                            eventHandler.apply(__this, arguments);
                        });
                        return __this;
                    },
                    errors: function (errorList) {
                        var form, $form, subSelector, errorClass;

                        subSelector = '.control-errors';
                        errorClass = 'control-error';

                        if (!errorList) {
                            errorList = [];
                        }
                        form = this;
                        $form = form.$get();
                        $form.find(`.${errorClass}`).each(function () {
                            var $error;
                            $error = $(this);
                            $error.slideUp(200, function () {
                                $error.remove();
                            })
                        });
                        setTimeout(() => {
                            var focusControlId;

                            $form.find('[data-control-type]').attr('data-control-errors', 'no');
                            $form.find(`.${errorClass}`).remove();
                            errorList.forEach(error => {
                                var selector, $control, $controlErrors;

                                selector = `[data-control-id="${error.field}"]`;

                                $control = $form.find(selector);
                                if ($control.length === 0) {
                                    console.warn(`Missing control: ${selector}`);
                                    return;
                                }

                                $controlErrors = $control.find(subSelector);
                                if ($controlErrors.length === 0) {
                                    console.warn(`Missing error container: ${selector} ${subSelector}`);
                                    return;
                                }

                                $control.attr('data-control-errors', 'yes');
                                $controlErrors.append(
                                    $('<div>').addClass(errorClass).append().html(error.message).hide().slideDown(400)
                                );
                            });

                            focusControlId = $form.find(`.${errorClass}`).filter(':visible').first().closest('[data-control-type]').attr('data-control-id');
                            if (focusControlId && form.view.controls.hasOwnProperty(focusControlId)) {
                                form.view.controls[focusControlId].scrollIntoView();
                            }
                        }, 200);
                    }
                };
            }

            renderSubTemplates(rootView, childNode, subTemplateVars || templateVars, escapeHTML);

            if (isSubTemplate) {
                templateId = subTemplateVars.partial;
                controlId = subTemplateVars.control;

                subTemplateVars.uuid = `uuid_${STATUS.uuid++}`;

                if (templateId) {
                    $childNode = $(childNode);
                    subView = renderTemplate(rootView, templateId, subTemplateVars, escapeHTML);
                    subView.$view.find('sub-template-children,.sub-template-children').first().replaceWith($childNode.children());

                    Object.keys(childNode.dataset).forEach(dataKey => {
                        subView.$view[0].dataset[dataKey] = childNode.dataset[dataKey];
                    });

                    $(childNode).replaceWith(subView.$view);
                    if (controlId) {
                        subView.name = controlId;

                        if (initControl(subView)) {
                            if (rootView.controls.hasOwnProperty(controlId)) {
                                console.warn(`Overwriting control reference: ${controlId}`);
                            }

                            rootView.controls[controlId] = subView;

                            if (rootView.currentForm) {
                                rootView.forms[rootView.currentForm].fields.push(subView);
                                rootView.forms[rootView.currentForm].controls[controlId] = subView;
                            }
                        }
                    }
                } else {
                    console.warn('Sub template without partial.', childNode);
                }
            }

            if (isSubTemplate && isForm) {
                rootView.currentForm = null;
            }
        });
    }

    function initControl(subView) {
        var controlType;

        controlType = subView.$view.attr('data-control-type');
        subView.type = controlType;

        if (!CONTROL_HANDLERS.hasOwnProperty(controlType)) {
            if ((controlType !== 'form') && (controlType !== 'selectOption')) {
                console.warn(`Form control without handlers detected: ${controlType}`, subView);
            }
            return false;
        }

        Object.keys(CONTROL_HANDLERS[controlType]).forEach(handlerName => {
            subView[handlerName] = function() {
                return CONTROL_HANDLERS[controlType][handlerName].apply(subView, arguments);
            };
        });

        setDefaultAttributes(controlType, subView);
        setDefaultControlAttributes(subView.$view.get()[0]);
        setDefaultControlHandlers(controlType, subView);

        return true;
    }

    function initTemplate($template) {
        $template.find('[data-info-popup]:not(.isInitialized)').addClass('isInitialized').each(function() {
            var info;

            info = this.dataset.infoPopup;
            if ((info !== '') && (info !== '{{info}}')) {
                this.addEventListener('click', _this.handleInfoPopupClick);
            } else {
                $(this).remove();
            }
        });

        $template.find('textarea.autosize:not(.isInitialized)').addClass('isInitialized').on('focus input change', function () {
            autosizeTextarea.call(this.parentNode);
        });

        $template.find('select.stealth:not(.isInitialized)').addClass('isInitialized').on('touchstart mousedown', function(event) {
            let $select;

            event.stopPropagation();
            event.preventDefault();

            $select = $(this);

            chmSelect.fromControl({
                $view: $select.parent(),
                get: function() {
                    return $select.val();
                },
                set: function(value) {
                    return $select.val(value);
                }
            });
        });

        $template.find('input[type="date"]:not(.isInitialized)').addClass('isInitialized').each(function() {
            this.type = 'text';
            this.dataset.type = 'date';

            DateTimePicker.activateDate(this);
        });

        $template.find('input[type="time"]:not(.isInitialized)').addClass('isInitialized').each(function() {
            this.type = 'text';
            this.dataset.type = 'time';

            DateTimePicker.activateTime(this);
        });
    }

    function autosizeTextarea() {
        var measure, textarea;

        measure = this.querySelector('.control-measure');
        textarea = this.querySelector('textarea');

        if (!measure || !textarea) {
            return;
        }

        measure.textContent = `${textarea.value} `;
        textarea.style.height = `${measure.offsetHeight}px`;
    }

    $(window).on('resize', function() {
        $('[data-control-type="textarea"] textarea.autosize').each(function() {
            autosizeTextarea.call(this.parentNode);
        });
    });

    _this = {
        render: function (templateId, templateVars, escapeHTML) {
            return new Promise(function (resolve, reject) {
                if (!ScoreTrekBattle.ASSETS.TEMPLATES.hasOwnProperty(templateId)) {
                    reject(`Missing template: ${templateId}`);
                    return;
                }

                resolve(
                    renderTemplate(null, templateId, templateVars, escapeHTML)
                );
            });
        },
        renderMulti: function (templateIds, templateVars, escapeHTML) {
            return new Promise(function (resolve, reject) {
                var promises, $templates;
                if (!templateVars) {
                    templateVars = {};
                }
                promises = [];
                $templates = {};
                templateIds.forEach(templateId => {
                    promises.push(
                        _this.render(templateId, templateVars.hasOwnProperty(templateId) ? templateVars[templateId] : null, escapeHTML).then($template => {
                            $templates[templateId] = $template;
                        })
                    );
                });
                Promise.all(promises).then(() => {
                    resolve($templates);
                }).catch(error => {
                    reject(error);
                });
            });
        },
        handleInfoPopupClick: function(event) {
            var infos;
            event.preventDefault();
            event.stopPropagation();
            infos = String(this.dataset.infoPopup).split(';').map(info => {
                return __i18n(info);
            });
            chmDialog.info(infos.join('<br>&nbsp;<br>'), __i18n('dialog/simple/explanation'), __i18n('button/gotIt'));
        }
    };

    $(document).on('click', '[data-info-popup]', _this.handleInfoPopupClick);

    return _this;
})();